'use strict';

(function($) {

    var pluginName = 'kumsalAdditional';

    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var additional = this;


        var Plugin = {
            isInit: false,
            sortable: null,
            options: {
                multiple: false,
                readonly: false,
                min: 0,
                max: 0,
                inputName: '',
            },
            maxAdditionalCondition: function(){
                return (!additional.options.multiple && additional.find('.kumsal-additional').length) ||
                    (additional.options.multiple && additional.options.max && additional.find('.kumsal-additional').length >= additional.options.max);
            },
            calculate:function(){
                additional.maxAdditionalCondition() ?
                    additional.find('.kumsal-additional-create').addClass('d-none') :
                    additional.find('.kumsal-additional-create').removeClass('d-none');
                additional.find('.kumsal-additional-input').attr('name',additional.options.inputName);
            },
            createAdditional:function(button){
                $(button).kumsalAction(Object.assign({}, $(button).data(),{
                    actionReady: function (action) {
                    },
                    actionSuccess: function (action,response) {
                        additional.find('.kumsal-additional-container').append(response.additional);
                        additional.calculate();
                        additional.find('.kumsal-additional-input').attr('name',additional.options.inputName)
                    },
                    formData: {
                        translation:$(button).parents('.kumsal-additionals').data('translation'),
                        language:$(button).parents('.kumsal-additionals').data('language')
                    }
                }));
            },
            editAdditional:function(button){
                $(button).kumsalAction(Object.assign({}, $(button).data(),{
                    actionReady: function (action) {
                    },
                    actionSuccess: function (action,response) {
                        $(action).parents('.kumsal-additional')[0].outerHTML = response.additional;
                        additional.calculate();
                    },
                    formData: {
                        translation:$(button).parents('.kumsal-additionals').data('translation'),
                        language:$(button).parents('.kumsal-additionals').data('language')
                    }
                }));
            },
            initEvents:function(){
                additional.on('click','.kumsal-additional-delete',function (event) {
                    event.preventDefault();
                    $(this).parents('.kumsal-additional').remove();
                    additional.calculate();
                });

                additional.on('click','.kumsal-additional-create',function (event) {
                    event.preventDefault();
                    if(!additional.maxAdditionalCondition()){
                        additional.createAdditional(this);
                    }
                });

                additional.on('click','.kumsal-additional-edit',function (event) {
                    event.preventDefault();
                    additional.editAdditional(this);
                });
            },
            initSortable:function(){
                additional.sortable = Sortable.create(additional.find('.kumsal-additional-container')[0], {
                    handle: '.kumsal-additional-drag',
                    animation: 150,
                    group: 'additionals',
                    onEnd: function (e) {
                        $(e.item).parents('.kumsal-additionals').kumsalAdditional().calculate()
                    },
                });
            },
            init: function() {
                additional.options = additional.data();

                additional.options.multiple = additional.options.multiple || false;
                additional.options.readonly = additional.options.readonly || false;
                additional.options.min = additional.options.min || 0;
                additional.options.max = additional.options.max || 0;
                additional.options.inpuName = additional.options.inpuName || '';

                additional.initEvents();

                if (additional.options.multiple){
                    additional.initSortable();
                }

                additional.calculate();

                return additional;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            additional[funcName] = func;
        });


        if (!additional.isInit){
            additional.init();
        }

        return additional;
    };

}(jQuery));

$('document').ready(function () {

    $(".kumsal-additionals").each(function( index ) {

        $(this).kumsalAdditional();
    });
});